import React, { useState, useEffect } from "react";
import { MainBlock } from "../../Main/styled";
import logoText from "./../../../resources/images/main/logo_text.svg";
import birdOrange from "./../../../resources/images/icons/bird_orange.svg";
import stars from "./../../../resources/images/icons/stars.svg";
import starsImg from "./../../../resources/images/main/stars_bg_1.png";
import emailBgImg from "./../../../resources/images/main/emailBg.jpg"
import { Container, Heading, Text, ImageItem } from "../../../styled";
import { OffersBlock } from "./styled";
import Button from "../../design_components/Button/Button";
import {
  blackColor,
  blueColor,
  greyDarkColor,
  greyLightColor,
  greyTextColor,
  lightSecondColor,
  orangeColor,
  purpleColor,
  purpleLightColor,
  purpleSecondColor,
  slideBgColor,
  whiteColor,
  greySecondColor,
  greyThirdColor, greyFourthColor
} from "../../../constants/colors";
import {
  email_paywall_50_list,
  EMAIL_PAYWALL_THEME_OBJ,
  PAYWALL_FIRST,
  sumObjYearly,
  sumObjMonthly,
  sumObj,
  EMAILS_PLANS,
  offerSubscriptionText,
  offerWhatYouGet, PAYWALL_FOURTH, TERMS_LINK, PRIVACY_LINK
} from "../../../constants/data";
import {
  CardInputWrapper,
  PaymentBlock,
  SubscriptionBlock,
} from "../../Subscription/styled";
import backIcon from "../../../resources/images/paywall/back.svg";
import { Elements } from "@stripe/react-stripe-js";
import PaymentForm from "../../Subscription/PaymentForm/PaymentForm";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector, useDispatch } from "react-redux";
import PopupTemplate from "../../design_components/Popup/PopupTemplate";
import { PaypalPopupBlock } from "../../Subscription/Paywall/styled";
import closeIcon from "../../../resources/images/paywall/close.svg";
import paypalLetters from "../../../resources/images/paymentForm/PP.svg";
import paypalBig from "../../../resources/images/paymentForm/pm_paypal.png";
import warningIcon from "../../../resources/images/paymentForm/warning.svg";
import {createEventObjectFunction, getCurrentYear} from "../../../utils/helper";
import { paymentInfoAddEvent } from "../../../firebaseAnalytics/events";
import { analytics } from "../../../firebaseAnalytics";
import { paymentInfoAddEventAmplitude } from "../../../amplitude/events";
import blueBg from "../../../resources/images/utils/blue.png";
import purpleBg from "../../../resources/images/utils/purple.png";
import { handleSetTheme } from "../../../store/questions/actions";
import { useDeviceType } from "../../../hooks/useDeviceType";

const Offers30 = (props) => {
  const { emailPaywallType } = props;

  const device = useDeviceType();

  const PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
  const pixelObject = useSelector((state) => state.questions.pixelObject);
  const remoteConfig = useSelector((state) => state.questions.remoteConfig);
  const landingId = useSelector((state) => state.questions.landingId);

  const [isFormVisible, setFormVisible] = useState(false);
  const [isWhyPopupVisible, setWhyPopupVisible] = useState(false);

  const [theme, setTheme] = useState(null);
  const [activePlanIndex, setActivePlanIndex] = useState(0);

  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(PUBLIC_KEY)
  );

  // payment method state
  const [isPaypalMethod, setPaypalMethod] = useState(false);
  const [isPaypalAvailable, setPaypalAvailable] = useState(true);

  const [isPaypalPopupVisible, setPaypalPopupVisible] = useState(false);
  const [paypalPopupState, setPaypalState] = useState(0);

  const [isInputFill, setInputFill] = useState(false);
  const [isInputError, setInputError] = useState(false);

  const [paypalInputClicked, setPaypalInputClicked] = useState(false);

  const purpleGradient =
    "linear-gradient(88.68deg, #AD3DBD -6.71%, #9A5BEA 105.98%)";

  const dispatch = useDispatch();

  useEffect(() => {
    setConfigParameters();
  }, [remoteConfig]);

  useEffect(() => {
    window.scrollTo(0, document.body);
  }, [isFormVisible]);

  const setConfigParameters = () => {
    setTheme(EMAIL_PAYWALL_THEME_OBJ[remoteConfig.paywallOfferId]);
    if (emailPaywallType === 1) {
      dispatch(handleSetTheme("dark"));
    }
  };

  const renderPopupContent = () => {
    return (
      <div>
        <Heading.Second style={{ marginBottom: 16, color: blackColor }}>
          Enjoy instant results!
        </Heading.Second>
        <Text.Fourth style={{ color: purpleColor, marginBottom: 16 }}>
          We ask for your payment information now so you can enjoy Journey
          uninterrupted after your <b>7-day trial ends.</b>
        </Text.Fourth>
        <Text.Fourth style={{ color: purpleColor, marginBottom: 47 }}>
          If you cancel anytime before the end of the <b>7-day trial,</b> you
          won’t be charged the annual membership fee.
        </Text.Fourth>
        <Button
          type={"default"}
          isGradient={true}
          text={"Got it"}
          action={() => setWhyPopupVisible(false)}
        />
      </div>
    );
  };

  const renderFirstEmailPaywall = () => {
    return (
      <MainBlock
        className={Object.keys(remoteConfig).length ? "visible" : null}
        style={{ paddingTop: 0 }}
      >
        <OffersBlock
          className={Object.keys(remoteConfig).length ? "visible" : null}
        >
          <OffersBlock.Bg>
            <img
              className="flowers"
              src={device === "mobile" ? emailBgImg : emailBgImg}
              alt=""
            />
          </OffersBlock.Bg>
          <Container.Content>
            <OffersBlock.Content>
              <OffersBlock.Top>
                <OffersBlock.Logo>
                  <img className="stars" src={logoText} />
                </OffersBlock.Logo>
              </OffersBlock.Top>
              <OffersBlock.Bottom>
                <OffersBlock.Stars>
                  <img className="stars" src={starsImg} />
                </OffersBlock.Stars>
                <Heading
                  style={{
                    fontSize: 28,
                    fontWeight: 800,
                    lineHeight: "36px",
                    color: whiteColor,
                  }}
                >
                  Get Journey Music
                </Heading>
                <Heading
                  style={{
                    fontSize: 28,
                    fontWeight: 500,
                    lineHeight: "36px",
                    color: whiteColor,
                    marginBottom: 13,
                  }}
                >
                  to sleep soundly
                </Heading>
                <Text.Third style={{ marginBottom: 30 }}>
                  <span style={{color: greyTextColor}}>$29.99 / 12 weeks</span>
                </Text.Third>
                <Button
                  text={"Continue"}
                  style={{ background: purpleGradient }}
                  type={"default"}
                  color={whiteColor}
                  action={() => setFormVisible(true)}
                />
              </OffersBlock.Bottom>
            </OffersBlock.Content>
            <OffersBlock.WhatYouGet>
              <Heading
                style={{
                  fontSize: 24,
                  fontWeight: 800,
                  lineHeight: "31px",
                  color: whiteColor,
                  marginBottom: 19,
                }}
              >
                What You Get:
              </Heading>
              <OffersBlock.WhatYouGet.Content>
                {offerWhatYouGet.map((item, index) => {
                  return <div className='what-you-get-item' key={index}>
                    <img src={item.img} alt='what you get'/>
                  <Text.Third style={{color: greyTextColor, marginTop: 13}}>{item.title}</Text.Third>
                  </div>
                })}
              </OffersBlock.WhatYouGet.Content>
              <Button
                text={"Continue"}
                style={{ background: purpleGradient, marginBottom: 36 }}
                type={"default"}
                color={whiteColor}
                action={() => setFormVisible(true)}
              />
            </OffersBlock.WhatYouGet>
            {/*<OffersBlock.What>
              <Heading
                style={{
                  fontSize: 24,
                  fontWeight: 800,
                  lineHeight: "31px",
                  color: whiteColor,
                  marginBottom: 19,
                }}
              >
                What You Get:
              </Heading>
              <div style={{ marginBottom: 36 }}>
                {email_paywall_50_list.map((item, index) => {
                  return (
                    <ImageItem
                      key={`${index}-list-paywall`}
                      style={{ marginBottom: 17 }}
                    >
                      <ImageItem.Img>
                        <img src={bird} alt="bird" />
                      </ImageItem.Img>
                      <ImageItem.Text>
                        <Text.Third
                          style={{ color: greyTextColor, textAlign: "left" }}
                        >
                          {item}
                        </Text.Third>
                      </ImageItem.Text>
                    </ImageItem>
                  );
                })}
              </div>
              <Button
                text={"Continue"}
                style={{ background: purpleGradient, marginBottom: 36 }}
                type={"default"}
                color={whiteColor}
                action={() => setFormVisible(true)}
              />
            </OffersBlock.What>*/}
            <SubscriptionBlock.Bottom style={{ padding: 0 }}>
              <Text.Fourth
                style={{
                  fontWeight: 800,
                  marginBottom: 2,
                  textAlign: "left",
                  color: lightSecondColor,
                }}
              >
                Your information is safe
              </Text.Fourth>
              <Text.Fourth
                style={{
                  marginBottom: 24,
                  textAlign: "left",
                  color: greyTextColor,
                }}
              >
                We will not sell or rent your personal contact information for
                any marketing purposes whatsoever.
              </Text.Fourth>
              <Text.Fourth
                style={{
                  fontWeight: 800,
                  marginBottom: 2,
                  textAlign: "left",
                  color: lightSecondColor,
                }}
              >
                Secure checkout
              </Text.Fourth>
              <Text.Fourth
                style={{
                  marginBottom: 24,
                  textAlign: "left",
                  color: greyTextColor,
                }}
              >
                All information is encrypted and transmitted without risk using
                a Secure Sockets Layer protocol.
              </Text.Fourth>
              <Text.Fourth
                style={{
                  fontWeight: 800,
                  marginBottom: 2,
                  textAlign: "left",
                  color: lightSecondColor,
                }}
              >
                Need any help?
              </Text.Fourth>
              <Text.Fourth
                style={{
                  marginBottom: 24,
                  textAlign: "left",
                  color: greyTextColor,
                }}
              >
                <span>Contact us </span>{" "}
                <a
                  href="mailto:support@gojourney.app"
                  style={{ color: "#CE53ED", textDecoration: "none" }}
                >
                  here
                </a>
              </Text.Fourth>
            </SubscriptionBlock.Bottom>
          </Container.Content>
        </OffersBlock>
      </MainBlock>
    );
  };

  const setColorDependTheme = (darkColor, lightColor) => {
    if (theme && theme === "dark") {
      return darkColor;
    } else {
      return lightColor;
    }
  };

  const renderSecondEmailPaywall = () => {
    return (
      <OffersBlock
        className={Object.keys(remoteConfig).length ? "visible" : null}
        style={{ paddingTop: 66, paddingBottom: 130 }}
        theme={theme}
      >
        <img className="blue" src={blueBg} alt="bg" />
        <img className="purple" src={purpleBg} alt="bg" />
        <Container.Content>
          <Heading
            style={{
              fontSize: 30,
              fontWeight: 800,
              lineHeight: "36px",
              color: setColorDependTheme(whiteColor, blackColor),
              marginBottom: 5,
              textAlign: "left",
            }}
          >
            Choose plan to achieve your Sleep Goal
          </Heading>
          <Text.Third
            style={{
              color: setColorDependTheme(greyTextColor, purpleSecondColor),
              marginBottom: 20,
              textAlign: "left",
            }}
          >
            One time payment, no hidden fees.
          </Text.Third>
          <OffersBlock.Comment
            style={{
              background: setColorDependTheme(
                "rgba(53, 48, 120, 0.2)",
                lightSecondColor
              ),
              marginBottom: 20,
            }}
          >
            <OffersBlock.Comment.Text>
              <Text.Fourth
                style={{
                  color: setColorDependTheme(whiteColor, blackColor),
                  textAlign: "left",
                }}
              >
                I’ve been meaning to get this for a while now. It was just one
                of those sleepless nights.
              </Text.Fourth>
            </OffersBlock.Comment.Text>
            <OffersBlock.Comment.Bottom>
              <Text.Fourth
                style={{
                  color: setColorDependTheme(greyTextColor, purpleSecondColor),
                  textAlign: "left",
                }}
              >
                — Amanda C.
              </Text.Fourth>
              <img src={stars} alt="stars" />
            </OffersBlock.Comment.Bottom>
          </OffersBlock.Comment>
          <OffersBlock.Plans>
            {EMAILS_PLANS.map((plan) => {
              return (
                <OffersBlock.Plan
                  key={`${plan.id}-plan`}
                  className={plan.index === activePlanIndex ? "active" : null}
                  style={{
                    background: setColorDependTheme(
                      lightSecondColor,
                      slideBgColor
                    ),
                  }}
                  onClick={() => setActivePlanIndex(plan.index)}
                >
                  <OffersBlock.Plan.Left>
                    <OffersBlock.Plan.Dot
                      className={
                        plan.index === activePlanIndex ? "active" : null
                      }
                    >
                      <OffersBlock.Plan.Dot.Item
                        className={
                          plan.index === activePlanIndex ? "active" : null
                        }
                      />
                    </OffersBlock.Plan.Dot>
                    <OffersBlock.Plan.Text>
                      <Text.Second
                        style={{
                          fontWeight: 700,
                          color: setColorDependTheme(
                            blackColor,
                            lightSecondColor
                          ),
                          marginBottom: 5,
                        }}
                      >
                        {plan.title}
                      </Text.Second>
                      <Text
                        style={{
                          fontWeight: 500,
                          fontSize: 18,
                          textAlign: "left",
                          color: setColorDependTheme(
                            purpleLightColor,
                            greyTextColor
                          ),
                        }}
                        theme={theme}
                      >
                        <span
                          className="decor"
                          style={{
                            color: setColorDependTheme(
                              purpleLightColor,
                              greyTextColor
                            ),
                            marginRight: 15,
                          }}
                        >
                          {`$${plan.fullSum}`}
                        </span>{" "}
                        <span
                          style={{
                            color: setColorDependTheme(
                              purpleLightColor,
                              greyTextColor
                            ),
                          }}
                        >
                          {`$${plan.finalSum}`}
                        </span>{" "}
                      </Text>
                    </OffersBlock.Plan.Text>
                  </OffersBlock.Plan.Left>
                  <OffersBlock.Plan.Right
                    style={{
                      background: setColorDependTheme(
                        "#CFCDF5",
                        "rgba(140, 138, 175, 0.2)"
                      ),
                    }}
                  >
                    <Text.Second
                      style={{
                        fontWeight: 700,
                        color: setColorDependTheme(
                          blackColor,
                          lightSecondColor
                        ),
                      }}
                    >
                      {`$${plan.perWeek}`}
                    </Text.Second>
                    <Text.Second
                      style={{
                        fontWeight: 500,
                        fontSize: 13,
                        lineHeight: "17px",
                        color: setColorDependTheme("#625F8B", greyTextColor),
                      }}
                    >
                      per week
                    </Text.Second>
                  </OffersBlock.Plan.Right>
                </OffersBlock.Plan>
              );
            })}
          </OffersBlock.Plans>
          <OffersBlock.What>
            <Heading
              style={{
                fontSize: 24,
                fontWeight: 800,
                lineHeight: "31px",
                color: setColorDependTheme(whiteColor, blackColor),
                marginBottom: 19,
                textAlign: "left",
              }}
            >
              What You Get:
            </Heading>
            <div style={{ marginBottom: 36 }}>
              {email_paywall_50_list.map((item, index) => {
                return (
                  <ImageItem
                    key={`${index}-list-paywall`}
                    style={{
                      marginBottom: 17,
                    }}
                  >
                    <ImageItem.Img
                      style={{
                        background: setColorDependTheme(
                          "rgba(69, 62, 164, 0.5)",
                          lightSecondColor
                        ),
                      }}
                    >
                      <img src={birdOrange} alt="bird" />
                    </ImageItem.Img>
                    <ImageItem.Text>
                      <Text.Third
                        style={{
                          color: setColorDependTheme(whiteColor, blackColor),
                          textAlign: "left",
                        }}
                      >
                        {item}
                      </Text.Third>
                    </ImageItem.Text>
                  </ImageItem>
                );
              })}
            </div>
          </OffersBlock.What>
          <SubscriptionBlock.Bottom style={{ padding: 0 }}>
            <Text.Fourth
              style={{
                fontWeight: 800,
                marginBottom: 2,
                textAlign: "left",
                color: setColorDependTheme(whiteColor, blackColor),
              }}
            >
              Your information is safe
            </Text.Fourth>
            <Text.Fourth
              style={{
                marginBottom: 24,
                textAlign: "left",
                color: setColorDependTheme(greyTextColor, purpleSecondColor),
              }}
            >
              We will not sell or rent your personal contact information for any
              marketing purposes whatsoever.
            </Text.Fourth>
            <Text.Fourth
              style={{
                fontWeight: 800,
                marginBottom: 2,
                textAlign: "left",
                color: setColorDependTheme(whiteColor, blackColor),
              }}
            >
              Secure checkout
            </Text.Fourth>
            <Text.Fourth
              style={{
                marginBottom: 24,
                textAlign: "left",
                color: setColorDependTheme(greyTextColor, purpleSecondColor),
              }}
            >
              All information is encrypted and transmitted without risk using a
              Secure Sockets Layer protocol.
            </Text.Fourth>
            <Text.Fourth
              style={{
                fontWeight: 800,
                marginBottom: 2,
                textAlign: "left",
                color: setColorDependTheme(whiteColor, blackColor),
              }}
            >
              Need any help?
            </Text.Fourth>
            <Text.Fourth
              style={{
                marginBottom: 24,
                textAlign: "left",
                color: greyTextColor,
              }}
            >
              <span
                style={{
                  color: setColorDependTheme(greyTextColor, purpleSecondColor),
                }}
              >
                Contact us{" "}
              </span>{" "}
              <a
                href="mailto:support@gojourney.app"
                style={{ color: orangeColor, textDecoration: "none" }}
              >
                here
              </a>
            </Text.Fourth>
          </SubscriptionBlock.Bottom>
        </Container.Content>
        <OffersBlock.ButtonBlock
          style={{ background: setColorDependTheme(blackColor, "#E0DFF0") }}
        >
          <Container.Content>
            <Button
              text={"Continue"}
              isGradient={true}
              type={"default"}
              color={whiteColor}
              action={() => setFormVisible(true)}
            />
          </Container.Content>
        </OffersBlock.ButtonBlock>
      </OffersBlock>
    );
  };

  const renderMainScreenFunction = () => {
    return emailPaywallType === 1
      ? renderFirstEmailPaywall()
      : renderSecondEmailPaywall();
  };

  const setCurrentProduct = () => {
    if (emailPaywallType === 1) {
      return process.env.REACT_APP_PRODUCT_29;
    } else {
      return EMAILS_PLANS[activePlanIndex].product;
    }
  };

  const setSumObj = () => {
    if (emailPaywallType === 1) {
      return sumObj;
    } else {
      return activePlanIndex === 1 ? sumObjMonthly : sumObjYearly;
    }
  };

  const paymentFormRender = () => {
    return (
      <div style={{ paddingTop: 15 }}>
        <Elements stripe={stripePromise}>
          <PaymentForm
            isPaypalMethod={isPaypalMethod}
            setPaypalMethod={setPaypalMethod}
            isPaypalAvailable={isPaypalAvailable}
            setPaypalAvailable={setPaypalAvailable}
            sumObj={setSumObj()}
            pixelObject={pixelObject}
            paypalActions={{ [PAYWALL_FIRST]: setPaypalPopupVisible,  [PAYWALL_FOURTH]: setPaypalPopupVisible}}
            setWhyPopupVisible={setWhyPopupVisible}
            currentProduct={setCurrentProduct()}
            withoutTrial={true}
            isEmailPaywall={true}
            isNewEmailPaywall={emailPaywallType === 1 ? true : null}
          />
        </Elements>
      </div>
    );
  };

  const renderPaypalPopup = () => {
    return (
      <PaypalPopupBlock>
        <div className="paypal-popup">
          <div className="paypal-popup-top">
            <img
              src={closeIcon}
              alt="close"
              onClick={() =>
                paypalPopupState === 0
                  ? setPaypalPopupVisible(false)
                  : handlePaypalClick()
              }
            />
          </div>
          <div
            className="paypal-popup-content"
            style={{ textAlign: paypalPopupState === 0 ? "center" : "left" }}
          >
            <img
              src={paypalPopupState === 0 ? paypalLetters : paypalBig}
              alt="letters"
            />
            <Heading.Fourth
              style={{
                marginBottom: 8,
                color: greyDarkColor,
                textAlign: paypalPopupState === 0 ? "center" : "left",
                fontWeight: 500,
              }}
            >
              {paypalPopupState === 0 ? "Pay with PayPal" : "We’re sorry"}
            </Heading.Fourth>
            <Heading.Fourth
              style={{
                marginBottom: 22,
                color: paypalPopupState === 0 ? greyDarkColor : greyLightColor,
                textAlign: paypalPopupState === 0 ? "center" : "left",
                fontWeight: 400,
                fontSize: 17,
                lineHeight: "22px",
              }}
            >
              {paypalPopupState === 0
                ? " Enter your email or mobile number to get started."
                : "Things don't appear to be working at the moment."}
            </Heading.Fourth>
            {paypalPopupState === 0 ? (
              <div style={{ position: "relative" }}>
                {isInputError ? (
                  <CardInputWrapper.Message.Paypal>
                    Required
                  </CardInputWrapper.Message.Paypal>
                ) : null}
                <CardInputWrapper.Paypal
                  isValid={!isInputError}
                  isComplete={isInputFill}
                  style={{ marginBottom: 40 }}
                  onClick={handleInputClick}
                >
                  <input
                    type="text"
                    placeholder={"Email or mobile number"}
                    onChange={(e) => handlePaypalInputChange(e.target.value)}
                  />
                  {isInputError ? (
                    <img
                      src={warningIcon}
                      style={{ position: "absolute", right: 14, top: 20 }}
                    />
                  ) : null}
                </CardInputWrapper.Paypal>
              </div>
            ) : null}
          </div>
          <div className="paypal-popup-button">
            <Button
              type={"default"}
              text={
                paypalPopupState === 0
                  ? "Next"
                  : "Return and pay with Сredit Сard"
              }
              action={() => handlePaypalClick()}
              style={{
                background: blueColor,
                height: 42,
              }}
              color={whiteColor}
              fontSize={17}
              fontWeight={400}
            />
          </div>
        </div>
      </PaypalPopupBlock>
    );
  };

  const handlePaypalInputChange = (value) => {
    if (value.length > 0) {
      setInputFill(true);
      setInputError(false);
    } else {
      setInputFill(false);
      setInputError(true);
    }
  };

  const handleInputClick = () => {
    if (paypalInputClicked === false) {
      const eventObj = createEventObjectFunction(null, null, landingId);
      // Событие №9 paymentinfo_add
      paymentInfoAddEvent(analytics, eventObj);
      paymentInfoAddEventAmplitude(eventObj);

      setPaypalInputClicked(true);
    } else {
      return false;
    }
  };

  const handlePaypalClick = () => {
    if (!isInputFill) {
      setInputError(true);
      return false;
    } else {
      if (paypalPopupState === 0) {
        setPaypalState(1);
      } else {
        setPaypalAvailable(false);
        setPaypalMethod(false);
        setPaypalPopupVisible(false);
      }
    }
  };

  const renderPaywallFunction = () => {
    return (
      <PaymentBlock style={{ paddingTop: 45 }}>
        <PaymentBlock.Back
          onClick={() => setFormVisible(false)}
          style={{ marginBottom: 0 }}
        >
          <img src={backIcon} alt="" />
        </PaymentBlock.Back>
        <PaymentBlock.Form>{paymentFormRender()}</PaymentBlock.Form>
        {emailPaywallType === 1 &&
          <SubscriptionBlock.Bottom.Separator>
            <div className="line" />
            <Text.Fifth style={{color: greyFourthColor, lineHeight: '18px', textAlign: 'left'}}>
              {offerSubscriptionText}
            </Text.Fifth>
          </SubscriptionBlock.Bottom.Separator>
        }
        <SubscriptionBlock.Bottom.New>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left", color: emailPaywallType === 1 ? blackColor : null }}
          >
            Your information is safe
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left", color: emailPaywallType === 1 ? blackColor : null }}>
            We will not sell or rent your personal contact information for any
            marketing purposes whatsoever.
          </Text.Fourth>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left", color: emailPaywallType === 1 ? blackColor : null }}
          >
            Secure checkout
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left", color: emailPaywallType === 1 ? blackColor : null }}>
            All information is encrypted and transmitted without risk using a
            SSL protocol.
          </Text.Fourth>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left", color: emailPaywallType === 1 ? blackColor : null }}
          >
            Need any help?
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left", color: emailPaywallType === 1 ? blackColor : null }}>
            <span>Contact us </span>{" "}
            <a
              href="mailto:support@gojourney.app"
              style={{ color: orangeColor, textDecoration: "none" }}
            >
              here
            </a>
          </Text.Fourth>
        </SubscriptionBlock.Bottom.New>
        {emailPaywallType === 1 &&
          <SubscriptionBlock.Footer.New style={{padding: '25px 0 10px'}}>
            <SubscriptionBlock.Footer.Top>
              <SubscriptionBlock.Footer.Top.Item>
                <a style={{ textDecoration: "none" }} href={TERMS_LINK}>
                  <Text.Third style={{ color: greySecondColor }}>
                    Terms of Use
                  </Text.Third>
                </a>
              </SubscriptionBlock.Footer.Top.Item>
              <SubscriptionBlock.Footer.Top.Item>
                <a style={{ textDecoration: "none" }} href={PRIVACY_LINK}>
                  <Text.Third style={{ color: greySecondColor }}>
                    Privacy Policy
                  </Text.Third>
                </a>
              </SubscriptionBlock.Footer.Top.Item>
            </SubscriptionBlock.Footer.Top>
            <SubscriptionBlock.Footer.Bottom>
              <Text.Fifth style={{ color: greyThirdColor }}>
                {`© ${getCurrentYear()} Journey Inc.`}
              </Text.Fifth>
              <Text.Fifth style={{ color: greyThirdColor }}>
                {` All Rights Reserved.`}
              </Text.Fifth>
            </SubscriptionBlock.Footer.Bottom>
          </SubscriptionBlock.Footer.New>}
      </PaymentBlock>
    );
  };

  return (
    <>
      {isFormVisible ? (
        <Container.Content> {renderPaywallFunction()} </Container.Content>
      ) : (
        renderMainScreenFunction()
      )}
      {isWhyPopupVisible && (
        <PopupTemplate contentFunction={renderPopupContent} />
      )}
      {isPaypalPopupVisible && (
        <PopupTemplate contentFunction={renderPaypalPopup} />
      )}
    </>
  );
};

export default Offers30;
